// extracted by mini-css-extract-plugin
module.exports = {"root":"EnhancedTableHead_root__2Af1w","row":"EnhancedTableHead_row__GvwqH","cell":"EnhancedTableHead_cell__1AEXK","actions":"EnhancedTableHead_actions__15G8z"};